import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Group } from '../model/Group';
import { Account } from '../model/Account';
import { AccountPageData } from '../model/AccountPageData';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccountPageService {
  constructor(private readonly http: HttpClient) {}

  preload(): Observable<AccountPageData> {
    return this.http.get<AccountPageData>('/ch/api/account');
  }

  updateAccount(command: Account) {
    return this.http.post('/ch/api/account/update-account', command);
  }

  updateGroup(command: Group) {
    return this.http.post('/ch/api/account/update-group', command);
  }
}
